import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AudienceService } from 'app/library/audience/services/audience.service';

@Component({
    selector: 'app-add-new-audience-dialog',
    templateUrl: './add-new-audience-dialog.component.html',
    styleUrls: ['./add-new-audience-dialog.component.scss'],
})
export class AddNewAudienceDialogComponent implements OnInit {
    @Input()
    audienceListTree: any; //TODO: [0] build failed with AudienceResource[];

    get name() {
        return this.formGroup.get('name');
    }
    get parent() {
        return this.formGroup.get('parent');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<AddNewAudienceDialogComponent>, public audienceService: AudienceService) {}

    ngOnInit() {
        this._formGroup = this._formBuilder.group({
            name: ['', Validators.required],
            parentId: ['', Validators.required],
        });
    }

    async onAddNewAudience() {
        const audience = this.formGroup.value;
        audience.parent = { id: audience.parentId };
        delete audience.parentId;
        this.dialogRef.close(await this.audienceService.createAudience(audience));
    }
}
